<header
  class="fixed inset-x-0 top-0 z-20 flex h-[72px] items-center justify-between border-b border-slate-200 bg-[#F8FAFC] px-4 md:px-8 lg:px-12"
  [class.rtl]="currentLanguage() === 'ar'"
>
  <div class="flex items-center gap-3">
    @if (isMobile() && isLoggedIn()) {
      <button
        type="button"
        class="flex flex-col gap-1.5 p-2 lg:hidden"
        (click)="toggleSidebar()"
        [attr.aria-expanded]="sidebarMenuOpen()"
        [attr.aria-label]="translationService.instant('header.openMenu', 'Open menu')"
      >
        <span class="block h-0.5 w-6 rounded bg-primary-500"></span>
        <span class="block h-0.5 w-6 rounded bg-primary-500"></span>
        <span class="block h-0.5 w-6 rounded bg-primary-500"></span>
      </button>
    }
    <img
      src="assets/images/renterz-logo.svg"
      alt="Renterz Logo"
      class="h-10 w-auto max-w-[160px] object-contain md:h-12 md:max-w-[180px]"
    />
  </div>

  <div class="flex items-center gap-2 md:gap-3">
    @if (isLoggedIn()) {
      @if (!isMobile()) {
        <button
          type="button"
          class="header-action-pill hidden items-center gap-2.5 sm:inline-flex"
          (click)="navigateHelp()"
        >
          <span class="header-help-icon" aria-hidden="true">
            <img src="assets/icons/new/help-support.png" alt="" />
          </span>
          <span class="text-sm font-medium text-text">
            {{ translationService.instant('header.helpSupport', 'Help & Support') }}
          </span>
        </button>

        <div
          class="inline-flex items-center rounded-xl border border-slate-200 bg-white p-1"
          role="group"
          [attr.aria-label]="translationService.instant('header.language', 'Language')"
        >
          <button
            type="button"
            class="rounded-lg px-3 py-1.5 text-xs font-semibold transition md:px-3.5 md:text-sm"
            [class.bg-primary-500]="currentLanguage() === 'en'"
            [class.text-white]="currentLanguage() === 'en'"
            [class.text-text-muted]="currentLanguage() !== 'en'"
            (click)="selectLanguage('en')"
          >
            EN
          </button>
          <button
            type="button"
            class="rounded-lg px-3 py-1.5 text-xs font-semibold transition md:px-3.5 md:text-sm"
            [class.bg-primary-500]="currentLanguage() === 'ar'"
            [class.text-white]="currentLanguage() === 'ar'"
            [class.text-text-muted]="currentLanguage() !== 'ar'"
            (click)="selectLanguage('ar')"
          >
            AR
          </button>
        </div>

        <app-view-toggle />
      }

      <div class="header-profile-wrap relative flex items-center gap-2" [class.header-profile-wrap--desktop]="!isMobile()">
        <button
          type="button"
          class="header-profile-trigger inline-flex items-center gap-2.5"
          [class.header-profile-trigger--compact]="isMobile()"
          [class.w-full]="!isMobile()"
          (click)="toggleDropdown()"
          [attr.aria-expanded]="isOpen"
          [attr.aria-label]="userName || translationService.instant('header.myProfile', 'My Profile')"
        >
          <span class="shrink-0 text-primary-500" aria-hidden="true">
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0 2c-2.67 0-8 1.34-8 4v1h16v-1c0-2.66-5.33-4-8-4Z"
              />
            </svg>
          </span>
          @if (!isMobile()) {
            <span class="min-w-0 flex-1 truncate text-start text-sm font-medium text-[#1e293b]">{{ userName }}</span>
          }
          <svg
            class="h-4 w-4 shrink-0 text-slate-500 transition-transform duration-200"
            [class.-rotate-180]="isOpen"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>

        @if (isOpen) {
          <div
            class="header-profile-menu absolute end-0 top-[calc(100%+8px)] z-30 w-full min-w-[200px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-[0_8px_24px_rgba(15,23,42,0.08)]"
          >
            @if (isMobile()) {
            <div class="header-profile-menu__user flex items-center gap-3 px-4 py-3.5">
              <span class="shrink-0 text-primary-500" aria-hidden="true">
                <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0 2c-2.67 0-8 1.34-8 4v1h16v-1c0-2.66-5.33-4-8-4Z"
                  />
                </svg>
              </span>
              <span class="min-w-0 truncate text-sm font-semibold text-[#1e293b]">{{ userName }}</span>
            </div>
            <div class="mx-4 border-t border-slate-200"></div>
            }

            <button
              type="button"
              class="flex w-full items-center gap-3 px-4 py-3.5 text-start text-sm font-medium text-[#1e293b] transition hover:bg-slate-50"
              (click)="navigateProfile()"
            >
              <svg class="h-5 w-5 shrink-0 text-slate-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <span>{{ translationService.instant('header.myProfile', 'My Profile') }}</span>
            </button>

            <div class="mx-4 border-t border-slate-200"></div>

            <button
              type="button"
              class="flex w-full items-center gap-3 px-4 py-3.5 text-start text-sm font-medium text-red-500 transition hover:bg-red-50"
              (click)="signOut()"
            >
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke-linecap="round" stroke-linejoin="round" />
                <polyline points="16 17 21 12 16 7" stroke-linecap="round" stroke-linejoin="round" />
                <line x1="21" y1="12" x2="9" y2="12" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>{{ translationService.instant('header.signout', 'Signout') }}</span>
            </button>
          </div>
        }
      </div>
    }
  </div>
</header>
